import { RawOrderMeta } from "./RawOrderMeta";
import { Ticket } from "./Ticket";


export class OrderMeta
{
    public Folder: string = "";
    public CreatedAt: Date = new Date(0);
    public UpdatedAt: Date = new Date(0);
    public CreatedBy: string = "";
    public UpdatedBy: string = "";
    public ChangesHistory: any[] = [];
    public Ticket: Ticket;

    public get IsNew(): boolean
    {
        return +this.UpdatedAt == 0;
    }

    constructor(raw?: RawOrderMeta)
    {
        this.Folder = raw?.Folder || "";
        this.CreatedAt = new Date(raw?.CreatedAt || 0);
        this.UpdatedAt = new Date(raw?.UpdatedAt || 0);
        this.CreatedBy = raw?.CreatedBy || "";
        this.UpdatedBy = raw?.UpdatedBy || "";
        this.ChangesHistory = raw?.ChangesHistory || [];
        this.Ticket = raw?.Ticket || {} as Ticket;
    }
}
